Pegasus.FormFields = [];

(function(){
  Pegasus.FormField = Em.Object.extend({
    type: '',
    name: '',
    optional: true,
    required: false,
    placeholder: function(_,value){
      if ( typeof(value) !== 'undefined' ) {
        return value || '';
      }
      return Em.I18n.t( 'form_fields.' + this.get('name') );
    }.property(),

    displayName: function(_,value){
      return Em.I18n.t( 'form_fields.' + this.get('name') );
    }.property(),

    toData: function(){
      return [
        this.get('type'),
        this.get('name'),
        this.get('placeholder'),
        ''+this.get('required')
      ].join('-delimiter-');
    }
  });

  [
    Pegasus.EmailAddressFormField = Pegasus.FormField.extend({
      optional: false,
      required: true,
      type: 'email',
      name: 'email_address'
    }),
    Pegasus.LastNameFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'last_name'
    }),
    Pegasus.FirstNameFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'first_name'
    }),
    Pegasus.CompanyNameFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'company_name'
    }),
    Pegasus.StreetAddressFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'street_address'
    }),
    Pegasus.ExtendedAddressFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'extended_address'
    }),
    Pegasus.BirthDateFormField = Pegasus.FormField.extend({
      type: 'date',
      name: 'birth_date'
    }),
    Pegasus.FaxFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'fax'
    }),
    Pegasus.WorkPhoneFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'work_phone'
    }),
    Pegasus.HomePhoneFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'home_phone'
    }),
    Pegasus.MobilePhoneFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'mobile_phone'
    }),
    Pegasus.WebsiteFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'website'
    }),
    Pegasus.TitleFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'title'
    }),
    Pegasus.LocalityFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'locality'
    }),
    Pegasus.PostalCodeFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'postal_code'
    }),
    Pegasus.RegionFormField = Pegasus.FormField.extend({
      type: 'text',
      name: 'region'
    })


  ].forEach(function(field){
    Pegasus.FormFields.addObject(field.create());
  });

})();
